import { Injectable } from '@angular/core';

import { SnLonLatBounds, SnLonLatBoundsLike } from '@lib/geo/helpers';
import { GoogleMap } from 'libs/geo/google/map/src';

import { BaseBoundsManagementService } from '../base-bounds-management.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleBoundsManagementService extends BaseBoundsManagementService {
  private _map?: GoogleMap;

  constructor() {
    super();
  }

  public setMap(map: GoogleMap): void {
    this._map = map;
  }

  public getBounds(): SnLonLatBounds {
    if (!this._map) {
      throw new Error('Map not set. Call setMap() first.');
    }
    
    const bounds = this._map.mapInstance.getBounds();
    if (!bounds) {
      throw new Error('Map bounds not available');
    }

    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();
    return new SnLonLatBounds([sw.lng(), sw.lat()], [ne.lng(), ne.lat()]);
  }

  public fitBounds(bounds: SnLonLatBoundsLike): void {
    if (!bounds || !this._map) return;

    // Convert SnLonLatBounds to Google Maps LatLngBounds
    const boundsInstance = SnLonLatBounds.convert(bounds);
    const sw = boundsInstance.getSouthWest();
    const ne = boundsInstance.getNorthEast();
    const googleBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(sw.lat, sw.lon), // sw
      new google.maps.LatLng(ne.lat, ne.lon), // ne
    );

    this._map.mapInstance.fitBounds(googleBounds);
  }

  public panToBounds(bounds: SnLonLatBoundsLike): void {
    if (!bounds || !this._map) return;

    // For Google Maps, panToBounds is similar to fitBounds but with padding
    const boundsInstance = SnLonLatBounds.convert(bounds);
    const sw = boundsInstance.getSouthWest();
    const ne = boundsInstance.getNorthEast();
    const googleBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(sw.lat, sw.lon), // sw
      new google.maps.LatLng(ne.lat, ne.lon), // ne
    );

    this._map.mapInstance.fitBounds(googleBounds, 50);
  }
}
